import { Box, Button, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import ReportHeader from "../../../../common/ReportHeader";
import { useDispatch, useSelector } from "react-redux";
import { otherReportMenu, reportMenu } from "../../../../../redux/Actions";
import MultiSelectDropDown from "../../../../form-components/MultiSelectDropDownComponent";
import CustomDatePicker from "../../../../common/CustomDatePicker";
import Alert from "../../../../common/Alert";
import MonthlyPassTable from "./MonthlyPassTable";
import { formatDate } from "../../../../../utilityFunctions";
import moment from "moment";
import { jsPdfDidParseCellCallback, jsPdfWillDrawCellCallback } from "../../../../generics/helper";
import { excelConfig } from "../../../../../assets/extra/excelConfig";
import excelExport from "../../../../../assets/extra/export-excel";
import { callAddFontRobotoBold } from "../../../../../assets/fonts/Roboto-bold";
import { callAddFontRobotoNormal } from "../../../../../assets/fonts/Roboto-normal";
import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import TextBox from "../../../../common/TextBox";
import { divisionFilterList, getCorporationListData } from "../../../../../redux/KSRTC_Redux/MasterConfig/MasterAction";
import { getMonthlyPassReportData } from "../../../../../redux/KSRTC_Redux/ReportsPage/ReportsAction";

const concessionData = [
	{ ConcessionID: 0, ConcessionName: "General Concession" },
	{ ConcessionID: 1, ConcessionName: "Senior Concession" },
];

const busTypeData = [
	{ BusTypeID: 0, BusTypeName: "Ordinary Service" },
	{ BusTypeID: 1, BusTypeName: "Express Service" },
];

const formatDivisionList = (list = []) => list?.map((val) => ({
	...val,
	DivisionCodeName: `${val?.DivisionName}(${val?.DivisionCode})`,
})) || [];

const MonthlyPass = () => {
	const dispatch = useDispatch();
	const store = useSelector((store) => store);
	const { user, masterConfig } = store;
	const LoginId = sessionStorage.getItem("LoginId");
	const [showReport, setShowReport] = useState(false);
	const [showAlert, setShowAlert] = useState(false);
	const [alertMsg, setAlertMsg] = useState("");
	const [tableData, setTabledata] = useState(false);
	const [filterOpt, setFilterOpt] = useState({
		corporationList: [],
		divisionList: [],
		completeDivisionList: [],
	});
	const [filterValue, setFilterValue] = useState({
		corporation: [],
		division: [],
		concession: concessionData,
		busType: busTypeData,
		fromDate: formatDate(
			window.getTime ? window.getTime() : new Date(),
		),
		toDate: formatDate(window.getTime ? window.getTime() : new Date()),
		mpnrNo: "",
	});

	useEffect(() => {
		const clientId = user?.CompanyID === 1 ? 1 : 2;
		dispatch(getCorporationListData({ CorporationID: 0, ClientID: clientId }, true, 60 * 60 * 1000));
		dispatch(divisionFilterList({ DivisionID: 0, CorporationID: 0, ClientID: clientId }, true, 60 * 60 * 1000));
	}, [dispatch, user?.CompanyID]);

	useEffect(() => {
		if (masterConfig?.corporationList?.length > 0) {
			const corporationList = masterConfig.corporationList.map((val) => ({
				...val,
				CorporationCodeName: `${val?.CorporationName}(${val?.CorporationCode})`,
			}));
			setFilterOpt((prev) => ({ ...prev, corporationList }));
			setFilterValue((prev) => ({
				...prev,
				corporation: prev.corporation?.length ? prev.corporation : corporationList,
			}));
		}
	}, [masterConfig?.corporationList]);

	useEffect(() => {
		const divisionList = formatDivisionList(masterConfig?.divisionList);
		setFilterOpt((prev) => ({ ...prev, divisionList, completeDivisionList: divisionList }));
		setFilterValue((prev) => ({
			...prev,
			division: divisionList,
		}));
	}, [masterConfig?.divisionList]);

	    const columnDefs = [
          { headerName: 'S. No.', exportHead: 'S. No.', field: 'SN', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '120px' }, showFilter: true },
          { headerName: 'Created Date', exportHead: 'Created Date', field: 'CreatedDate', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '300px' }, showFilter: true },
          { headerName: 'MPNR No.', exportHead: 'MPNR No.', field: 'MPNRNo', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '300px' }, showFilter: true },
          { headerName: 'Pass No.', exportHead: 'Pass No.', field: 'PassNo', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '300px' }, showFilter: true },
          { headerName: 'Pass Issued On', exportHead: 'Pass Issued On', field: 'PassIssuedOn', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '300px' }, showFilter: true },
          { headerName: 'Corporation', exportHead: 'Corporation', field: 'Corporation', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '300px' }, showFilter: true },
          { headerName: 'Division', exportHead: 'Division', field: 'Division', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '300px' }, showFilter: true },
          { headerName: 'From Palce', exportHead: 'From Palce', field: 'FromPalce', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '300px' }, showFilter: true },
          { headerName: 'To Place', exportHead: 'To Place', field: 'ToPlace', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '300px' }, showFilter: true },
          { headerName: 'Name', exportHead: 'Name', field: 'Name', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '300px' }, showFilter: true },
          { headerName: 'Gender', exportHead: 'Gender', field: 'Gender', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '300px' }, showFilter: true },
          { headerName: 'Age', exportHead: 'Age', field: 'Age', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '300px' }, showFilter: true },
          { headerName: 'Concession', exportHead: 'Concession', field: 'Concession', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '300px' }, showFilter: true },
          { headerName: 'Bus Type', exportHead: 'Bus Type', field: 'BusType', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, headerSx: { textAlign: 'left', width: '300px' }, showFilter: true },
      ];
	const divisionProps = () => {
		return {
			id: "division",
			width: "100%",
			name: "division",
			label: "",
			isCompulsory: false,
			options: filterOpt?.divisionList || [],
			preSelectedValues: filterValue?.division,
			searchPlaceholder: "Search by Division",
			disabled: false,
			isObject: true,
			primaryKey: "DivisionID",
			labelKey: "DivisionCodeName",
			singleSelect: true,
			selectAllOption: true,
			defaultAllSelected: true,
			searchByCode: true,
			searchByName: "DivisionCode",
			prevId: "corporation",
			nextId: "concession",
		};
	};
	const corporationProps = () => {
		return {
			id: "corporation",
			width: "100%",
			name: "corporation",
			label: "",
			isCompulsory: false,
			options: filterOpt?.corporationList || [],
			preSelectedValues: filterValue?.corporation,
			searchPlaceholder: "Search by Corporation",
			disabled: false,
			isObject: true,
			primaryKey: "CorporationID",
			labelKey: "CorporationCodeName",
			singleSelect: true,
			selectAllOption: true,
			defaultAllSelected: true,
			prevId: "",
			nextId: "division",
			searchByCode: true,
			searchByName: "CorporationCode",
			listWidth: "600px",
		};
	};
	const busTypeProps = () => {
		return {
			id: "busType",
			width: "100%",
			name: "busType",
			label: "",
			isCompulsory: false,
			options: busTypeData,
			preSelectedValues: filterValue?.busType,
			searchPlaceholder: "Search by Bus Type",
			disabled: false,
			isObject: true,
			primaryKey: "BusTypeID",
			labelKey: "BusTypeName",
			singleSelect: true,
			selectAllOption: true,
			defaultAllSelected: true,
			searchByName: "BusTypeName",
			prevId: "concession",
			nextId: "fromDate",
		};
	};
	const concessionProps = () => {
		return {
			id: "concession",
			width: "100%",
			name: "concession",
			label: "",
			isCompulsory: false,
			options: concessionData,
			preSelectedValues: filterValue?.concession,
			searchPlaceholder: "Search by Concession",
			disabled: false,
			isObject: true,
			primaryKey: "ConcessionID",
			labelKey: "ConcessionName",
			singleSelect: true,
			selectAllOption: true,
			defaultAllSelected: true,
			searchByName: "ConcessionName",
			prevId: "division",
			nextId: "busType",
		};
	};

	const handleCorporationSelect = (val) => {
		const selectedCorporationID = val?.length === 1 ? val[0]?.CorporationID : 0;
		const divisionList = selectedCorporationID
			? filterOpt?.completeDivisionList?.filter((item) => item?.CorporationID === selectedCorporationID)
			: filterOpt?.completeDivisionList;

		setFilterOpt((prev) => ({ ...prev, divisionList }));
		setFilterValue((prev) => ({
			...prev,
			corporation: val,
			division: divisionList,
		}));
	};

	const getSelectedId = (list, key) => {
		if (!list?.length || list.length > 1) return key === "ConcessionID" || key === "BusTypeID" ? -1 : 0;
		return list[0]?.[key] ?? (key === "ConcessionID" || key === "BusTypeID" ? -1 : 0);
	};

	const getMonthlyPassParams = () => {
		const mpnrNo = filterValue?.mpnrNo?.trim();
		return {
			CorporationID: getSelectedId(filterValue?.corporation, "CorporationID"),
			DivisionID: getSelectedId(filterValue?.division, "DivisionID"),
			ConcessionID: getSelectedId(filterValue?.concession, "ConcessionID"),
			BusTypeID: getSelectedId(filterValue?.busType, "BusTypeID"),
			FromDT: mpnrNo ? "''" : moment(filterValue?.fromDate).format("YYYY-MM-DD"),
			ToDT: mpnrNo ? "''" : moment(filterValue?.toDate).format("YYYY-MM-DD"),
			...(mpnrNo ? { MPNR: mpnrNo } : {}),
			usage: "dev",
		};
	};

	const formatReportData = (rows = []) => rows.map((item, index) => ({
		...item,
		SN: item?.SN || item?.SlNo || index + 1,
		CreatedDate: item?.CreatedDate || item?.UsedDate || "",
		MPNRNo: item?.MPNRNo || item?.MPNR || "",
		PassNo: item?.PassNo || item?.PassNumber || "",
		PassIssuedOn: item?.PassIssuedOn || "",
		Corporation: item?.Corporation || item?.CorporationName || "",
		Division: item?.Division || item?.DivisionName || "",
		FromPalce: item?.FromPalce || item?.FromPlace || item?.FromCity || "",
		ToPlace: item?.ToPlace || item?.ToCity || "",
		Name: item?.Name || item?.PassHolderName || "",
		Gender: item?.Gender || "",
		Age: item?.Age ?? "",
		Concession: item?.Concession || "",
		BusType: item?.BusType || "",
		isDataRow: true,
	}));

	const fetchReportData = async (showNoDataAlert = false) => {
		const res = await dispatch(getMonthlyPassReportData(getMonthlyPassParams()));
		if (res?.status === 200 && res?.data?.status) {
			const reportData = formatReportData(res?.data?.Data?.Table || []);
			if (showNoDataAlert && !(reportData?.length > 0)) {
				handleAlert("No Data Found");
			}
			return reportData;
		}
		handleAlert(res?.data?.Message || "No Data Found !");
		return [];
	};

	const handleSumbit = async () => {
		setShowReport(false);
		setTabledata({});
		const data = await fetchReportData(true);
		if (data?.length > 0) {
			setShowReport(true);
			setTabledata({ data, filterValue });
		}
	};

	const handleResetValue = () => {
		const divisionList = filterOpt?.completeDivisionList || [];
		setFilterOpt((prev) => ({
			...prev,
			divisionList,
		}));
		setFilterValue({
			corporation: filterOpt?.corporationList || [],
			division: divisionList,
			concession: concessionData,
			busType: busTypeData,
			fromDate: formatDate(window.getTime ? window.getTime() : new Date()),
			toDate: formatDate(window.getTime ? window.getTime() : new Date()),
			mpnrNo: "",
		});
	};
	const handleAlert = (msg) => {
	setShowAlert(true);
	setAlertMsg(msg);
	};

	   // for Export as excel
    const reportExcelExport = async (param = "xlsx") => {
      const reportData = await fetchReportData();
      if (!(reportData?.length > 0)) {
        handleAlert("No Data Found !")
        return
      }
      try {
        const xlColumns = columnDefs.map((col) => {
          return {
            colHeader: col.exportHead,
            field: col.field,
            xlCol: col.xlCol,
          };
        });

        const xlConfig = {
          ...excelConfig,
          columns: xlColumns,
          fileName: `Monthly_Pass.${param}`,
          showFilterSection: true,
          showSummarySection: true,
          showEmptyRow: true,
          headerRowStyle: { fill: "", bold: true },
          borderStyle: {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          },
          showHeader: true,
          workSheetTitle: `Monthly_Pass`,
          headerFooter: {
            firstHeader: "Monthly_Pass",
            firstFooter: "Monthly_Pass",
          },
          sheetHeaderData: [
            {
              caption: "KARNATAKA STATE ROAD TRANSPORT CORPORATION",
              colSpan: 10,
              horizontal: "center",
              newRow: true,
            },
            {
              caption:
                "Monthly Pass",
              colSpan: 10,
              size: 12,
              horizontal: "center",
              newRow: true,
            },
            {
              caption: ` From Date : ${moment(filterValue.fromDate).format("DD-MMM-YYYY")}`,
              value: ` To Date : ${moment(filterValue.toDate).format("DD-MMM-YYYY")}`,
              colSpan: 5,
              size: 10,
            },
            {
              caption: `User : ${user?.UserName} (${LoginId})`,
              value: "",
              colSpan: 5,
              horizontal: "right",
              size: 10,
              newRow: true,
            },
            {
              caption: `Division : ${filterValue?.division.length > 1
                ? "All"
                : filterValue?.division[0]?.DivisionCode
                } `,
              value: ``,
              colSpan: 5,
              size: 10,
            },
            {
              caption: `Print Date & Time : ${moment(
                window.getTime ? window.getTime() : new Date()
              ).format("DD-MMM-YYYY HH:mm")}`,
              value: "",
              colSpan: 5,
              horizontal: "right",
              size: 10,
              newRow: true,
            },
            {
              caption: `Corporation : ${filterValue?.corporation.length > 1 ? "All" : filterValue?.corporation[0]?.CorporationCode} `,
              value: ``,
              colSpan: 5,
              size: 10,
            },
            {
              caption: ``,
              value: "",
              colSpan: 5,
              horizontal: "right",
              size: 10,
              newRow: true,
            },
            {
              caption: `Concession : ${filterValue?.concession.length > 1 ? "All" : filterValue?.concession[0]?.ConcessionName} `,
              value: ``,
              colSpan: 5,
              size: 10,
            },
            {
              caption: ``,
              value: "",
              colSpan: 5,
              horizontal: "right",
              size: 10,
              newRow: true,
            },
            {
              caption: `Bus Type : ${filterValue?.busType.length > 1 ? "All" : filterValue?.busType[0]?.BusTypeName} `,
              value: ``,
              colSpan: 5,
              size: 10,
            },
          ],
        };
        await excelExport.processExcel(xlConfig, reportData);
      } catch (err) {
        console.log(err);
      }
    };

    // for Export as Pdf and Print
   const printReport = async (param = "pdf") => {
		const reportData = await fetchReportData();
		if (!(reportData?.length > 0)) {
			handleAlert("No Data Found !");
			return;
		}
		try {
			const cancellationColumns = columnDefs.map((col) => {
				return {
					header: col.exportHead,
					dataKey: col.field,
					xlCol: col.xlCol,
				};
			});

			jsPDF.API.events.push(["addFonts", callAddFontRobotoBold]);
			jsPDF.API.events.push(["addFonts", callAddFontRobotoNormal]);

			const doc = new jsPDF({
				orientation: "l",
				format: "a4",
			});

			var totalPagesExp = "{total_pages_count_string}";
			doc.autoTableSetDefaults({
				headStyles: {
					fontSize: 8,
					halign: "left",
					fillColor: [30, 89, 167],
				},
			});

			const pageWidth = doc.internal.pageSize.width; // Get the page width
			const startY = 10;

			// Add the text at the top of the page
			doc.setFontSize(14);
			doc.setTextColor("#000000");
			doc.setFont("Roboto", "bold");

			const title = "KARNATAKA STATE ROAD TRANSPORT CORPORATION";
			const titleWidth = doc.getTextWidth(title);
			doc.text(title, (pageWidth - titleWidth) / 2, startY); // Center align

			doc.setFont("Roboto", "normal");
			doc.setFontSize(10);

			const subTitle = "Monthly Pass Report";
			const subTitleWidth = doc.getTextWidth(subTitle);
			doc.text(subTitle, (pageWidth - subTitleWidth) / 2, startY + 8); // Center align

			doc.setFontSize(10);
			doc.setTextColor("#000000");
			doc.text(
				`From Date: ${moment(filterValue.fromDate).format("DD-MMM-YYYY")} - To Date: ${moment(filterValue.toDate).format("DD-MMM-YYYY")}`,
				5,
				startY + 14,
			);
			doc.text(
				`User: ${user?.UserName || ""} (${sessionStorage.getItem("LoginId") || ""})`,
				doc.internal.pageSize.width - 5,
				startY + 14,
				"right",
			);
			doc.text(
				`Division: ${filterValue?.division.length > 1 ? "All" : filterValue?.division[0]?.DivisionCode}`,
				5,
				startY + 20,
			);
			doc.text(
				`Print Date & Time : ${moment(window.getTime ? window.getTime() : new Date()).format("DD-MMM-YYYY HH:mm")}`,
				doc.internal.pageSize.width - 5,
				startY + 20,
				"right",
			);
			doc.text(
				`Corporation: ${filterValue?.corporation.length > 1 ? "All" : filterValue?.corporation[0]?.CorporationCode}`,
				5,
				startY + 26,
			);
			doc.text(
				`Concession: ${filterValue?.concession.length > 1 ? "All" : filterValue?.concession[0]?.ConcessionName}`,
				5,
				startY + 32,
			);
			doc.text(
				`Bus Type: ${filterValue?.busType.length > 1 ? "All" : filterValue?.busType[0]?.BusTypeName}`,
				5,
				startY + 38,
			);

			// Print the table on the first page
			autoTable(doc, {
				startY: 50,
				margin: { top: 3, left: 5, right: 5, bottom: 3 },
				tableWidth: "auto",
				columns: cancellationColumns,
				body: reportData,
				columnStyles: {
					0: { halign: "left", fontSize: 7 },
					1: { halign: "left", fontSize: 7 },
					2: { halign: "left", fontSize: 7 },
					3: { halign: "left", fontSize: 7 },
					4: { halign: "left", fontSize: 7 },
					5: { halign: "left", fontSize: 7 },
					6: { halign: "left", fontSize: 7 },
					7: { halign: "left", fontSize: 7 },
					8: { halign: "left", fontSize: 7 },
					9: { halign: "left", fontSize: 7 },
					10: { halign: "left", fontSize: 7 },
					11: { halign: "left", fontSize: 7 },
					12: { halign: "left", fontSize: 7 },
					13: { halign: "left", fontSize: 7 },
				},
				theme: "grid",
				headStyles: {
					fillColor: null,
					textColor: [0, 0, 0],
					lineWidth: 0.2,
				},
				didParseCell: (data) => {
					jsPdfDidParseCellCallback(data, cancellationColumns, []);
				},
				willDrawCell: (data) => {
					jsPdfWillDrawCellCallback(data, true);
				},
				didDrawPage: function (data) {
					data.settings.margin.top = 16;
				},
				pageBreak: "auto",
			});
			if (typeof doc.putTotalPages === "function") {
				doc.putTotalPages(totalPagesExp);
			}

			if (param === "print") {
				const pdfBlob = new Blob([doc.output("blob")], {
					type: "application/pdf",
				});
				const pdfUrl = URL.createObjectURL(pdfBlob);
				window.open(pdfUrl);
			} else {
				const pdfData = doc.output("blob");
				const pdfUrl = URL.createObjectURL(pdfData);
				const link = document.createElement("a");
				link.href = pdfUrl;
				link.download = "Monthly_Pass.pdf";
				link.click();
			}
		} catch (error) {
			console.log("Error: ", error);
		}
	};

	return (
		<>
			{!showReport ? (
				<Box>
					<ReportHeader
						mainHeaderName="Report"
						headerName="Other Report"
						openSubMenu={() => dispatch(reportMenu(true))}
						subHeader={"Monthly Pass Report"}
						subHeaderVisible={() => dispatch(otherReportMenu(true))}
					/>
					<Grid
						container
						spacing={0}
						className="column-container"
						style={{ padding: "16px 16px 58px 16px" }}
					>
						<Grid
							item
							md={6.5}
							style={{
								display: "flex",
								flexDirection: "column",
								gap: "16px",
							}}
						>
							<Grid
								container
								direction="row"
								style={{
									paddingRight: "30px",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}}
							>
								<Grid item md={4} style={{ fontWeight: "600" }}>
									Corporation
								</Grid>
								<Grid item md={8}>
									<MultiSelectDropDown
										{...corporationProps()}
										onSelect={(val) => {
											handleCorporationSelect(val);
										}}
									/>
								</Grid>
							</Grid>
							<Grid
								container
								direction="row"
								style={{
									paddingRight: "30px",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}}
							>
								<Grid item md={4} style={{ fontWeight: "600" }}>
									Division
								</Grid>
								<Grid item md={8}>
									<MultiSelectDropDown
										id="division"
										{...divisionProps()}
										onSelect={(val) => {
											setFilterValue((prev) => ({ ...prev, division: val }));
										}}
									/>
								</Grid>
							</Grid>
							<Grid
								container
								direction="row"
								style={{
									paddingRight: "30px",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}}
							>
								<Grid item md={4} style={{ fontWeight: "600" }}>
									Concession
								</Grid>
								<Grid item md={8}>
									<MultiSelectDropDown
										{...concessionProps()}
										onSelect={(val) => {
											setFilterValue((prev) => ({ ...prev, concession: val }));
										}}
									/>
								</Grid>
							</Grid>
							<Grid
								container
								direction="row"
								style={{
									paddingRight: "30px",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}}
							>
								<Grid item md={4} style={{ fontWeight: "600" }}>
									Bus Type
								</Grid>
								<Grid item md={8}>
									<MultiSelectDropDown
										{...busTypeProps()}
										onSelect={(val) => {
											setFilterValue((prev) => ({ ...prev, busType: val }));
										}}
									/>
								</Grid>
							</Grid>

							<Grid
								container
								direction="row"
								style={{
									paddingRight: "30px",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}}
							>
								<Grid item md={4} style={{ fontWeight: "600" }}>
									From Date
								</Grid>
								<Grid item md={8}>
									<CustomDatePicker
										id="fromDate"
										selectedDate={filterValue?.fromDate}
										onChange={(value) => {
											setFilterValue((prev) => ({
												...prev,
												fromDate: formatDate(value),
											}));
											if (
												new Date(value) <
												new Date(filterValue.toDate)
											) {
												setFilterValue({
													...filterValue,
													fromDate: formatDate(value),
												});
											} else {
												setFilterValue({
													...filterValue,
													fromDate: formatDate(value),
													toDate: formatDate(value),
												});
											}
										}}
										// onKeyDown={(e) => {
										//   navigation1(e, "toDate", "station");
										// }}
										minDate={"2024-06-19"}
									/>
								</Grid>
							</Grid>
							<Grid
								container
								direction="row"
								style={{
									paddingRight: "30px",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}}
							>
								<Grid item md={4} style={{ fontWeight: "600" }}>
									To Date
								</Grid>
								<Grid item md={8}>
									<CustomDatePicker
										id="toDate"
										selectedDate={filterValue?.toDate}
										onChange={(value) => {
											setFilterValue((prev) => ({
												...prev,
												toDate: formatDate(value),
											}));
										}}
										// onKeyDown={(e) => {
										//   navigation1(e, "toDate", "station");
										// }}
										minDate={moment(
											filterValue?.fromDate,
										).format("YYYY-MM-DD")}
									/>
								</Grid>
							</Grid>
							<div style={{textAlign: 'center'}}>OR</div>
							<Grid
								container
								direction="row"
								style={{
									paddingRight: "30px",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}}
							>
								<Grid item md={4} style={{ fontWeight: "600" }}>
									MPNR No.
								</Grid>
								<Grid item md={8}>
									<TextBox
										type="text"
										label="MPNR No."
										value={filterValue?.mpnrNo}
										onChange={(e) => {
											setFilterValue((prev) => ({
												...prev,
												mpnrNo: e.target.value,
											}));
										}}
										name="MPNRNo"
										// onKeyDown={(e) => {
										// 	navigation1(
										// 		e,
										// 		"journeyDate",
										// 		"TicketNo",
										// 	);
										// }}
									/>
								</Grid>
							</Grid>
							<Grid
								container
								direction="row"
								style={{
									paddingRight: "30px",
									gap: "10px",
									flexWrap: "nowrap",
								}}
							>
								<Grid item md={4}></Grid>
								<Grid item md={2}>
									<Button
										variant="contained"
										size="medium"
										id="submitButton"
										className="btn-orange"
										onClick={handleSumbit}
										// onKeyDown={(e) => navigation3(e, "pdfButton", "toDate", handleSumbit)}
									>
										Submit
									</Button>
								</Grid>
								<Grid item md={2}>
									<Button
										variant="outlined"
										size="medium"
										id="pdfButton"
										className="btn-orange-outline"
										//  onClick={() => handleSumbit(1, "pdf")}
										onClick={() => printReport("pdf")}
										//   onKeyDown={(e) => navigation3(e, "excelButton", "submitButton", () => handleSumbit(1, "pdf"))}
									>
										PDF
									</Button>
								</Grid>
								<Grid item md={2}>
									<Button
										variant="outlined"
										size="medium"
										id="excelButton"
										className="btn-orange-outline"
										// onClick={() => handleSumbit(2, "xlsx")}
										onClick={() =>
											reportExcelExport("xlsx")
										}
										// onKeyDown={(e) => navigation3(e, "restButton", "pdfButton", () => handleSumbit(2, "xlsx"))}
									>
										EXCEL
									</Button>
								</Grid>
								<Grid item md={2}>
									<Button
										variant="outlined"
										size="medium"
										id="restButton"
										className="btn-orange-outline"
										// onClick={handleResetValue}
										onClick={handleResetValue}
										// onKeyDown={(e) => navigation3(e, "division", "excelButton", handleResetValue)}
									>
										RESET
									</Button>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Box>
			) : (
				<MonthlyPassTable
					handleBack={() => {
						setShowReport(false);
						setTabledata({});
					}}
					data={tableData?.data || []}
					filterValue={tableData?.filterValue || filterValue}
				/>
			)}
			{showAlert && (
				<Alert
					msg={alertMsg}
					alertType={"error"}
					close={() => setShowAlert(false)}
					buttonText="Ok"
				/>
			)}
		</>
	);
};

export default MonthlyPass;
